// React & Redux
import React from 'react';
import styled from 'styled-components';

// Components
import { Image, Text } from 'sc-ui';

// Images
import Logo from 'images/logo.svg';

const propTypes = {};
const defaultProps = {};

export class ThankyouPage extends React.Component {
    render() {
        return (
            <Layout>
                <Text size="med">Smoothie Club has closed its doors.</Text>
                <br />
                <Text size="sm" style={{ maxWidth: '600px', textAlign: 'center' }}>
                    To everyone who came on this journey with us: your kindness and encouragement
                    (and business) meant so much to us.
                </Text>
                <br />
                <Text size="lrg">Thank you!</Text>
                <Image src={Logo} size="xxxlrg" />
            </Layout>
        );
    }
}

const Layout = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/views/ThankyouPage/ThankyouPage.jsx